
export const getStatisticsQueryInfo = (state) => state.statistics.queryInfo;